var _circle, _text;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLotNotSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18,
    stroke: "currentColor",
    strokeWidth: 2.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 20.5,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fill: "currentColor",
    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "-0.02em"
  }, "\n    N/A\n  ")));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotNotSet);
export default __webpack_public_path__ + "static/media/lot_not_set.b17a4641e57559fdce2c60efa754a5be.svg";
export { ForwardRef as ReactComponent };